import moment from 'moment-timezone';

import {
    PromotedPostsMetricsStatuses,
} from 'app/promoted-posts-metrics/promoted-posts-metrics-constants/promoted-posts-metrics-constants';

export function getParsedStatus(rawStatus, endTime) {
  const isRunning = getIsCurrentlyRunning(endTime);
  return status = parseStatus(rawStatus, isRunning);
}

function getIsCurrentlyRunning(endTime) {
  const currentDate = moment();
  const endDate = moment(endTime);
  return currentDate.isBefore(endDate);
}

function parseStatus(rawStatus, isCurrentlyRunning: boolean) {
    // TODO: Confirm translation for each effective_status
  switch (rawStatus.toLowerCase()) {
    case 'active':
    case 'running':
    case 'preapproved': // ???
            // Facebook does not update the status of an ad after its end time, so check that here
      return isCurrentlyRunning ? PromotedPostsMetricsStatuses.RUNNING : PromotedPostsMetricsStatuses.ENDED;
    case 'campaign_paused':
    case 'adset_paused':
    case 'paused':
            // Facebook does not update the status of an ad after its end time, so check that here
      return isCurrentlyRunning ? PromotedPostsMetricsStatuses.PAUSED : PromotedPostsMetricsStatuses.ENDED;
    case 'deleted':
    case 'archived':
      return PromotedPostsMetricsStatuses.DELETED;
    case 'pending_review':
    case 'pending_billing_info': // ???
      return PromotedPostsMetricsStatuses.PENDING;
    case 'disapproved':
      return PromotedPostsMetricsStatuses.ERROR;
    default:
      return PromotedPostsMetricsStatuses.ERROR;
  }
}
